import { Control } from "react-hook-form";
import AsyncSelect from "../../../components/common/Select/AsyncSelect";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { useDirectionList } from "../../../hooks/useInteraction";
import FormHelperText from "@mui/material/FormHelperText/FormHelperText";
import { FormGroup } from "@mui/material";

interface AsyncDirectionSelectProps {
  name: string;
  size?: "small" | "medium";
  control: Control;
  label?: string;
  fullWidth?: boolean;
}

export function AsyncDirectionSelect({
  name,
  size = "medium",
  control,
  label = "",
  fullWidth = false,
}: Readonly<AsyncDirectionSelectProps>) {
  const { customerId } = useParams();
  const [isReady, setIsReady] = useState(false);

  const {
    data: options,
    error,
    isLoading,
  } = useDirectionList(customerId, isReady);

  return (
    <FormGroup className="w-full">
      <AsyncSelect
        setIsReady={setIsReady}
        error={!!error}
        name={name}
        control={control}
        label={label}
        fullWidth={fullWidth}
        size={size}
        options={options ?? []}
        loading={isLoading}
        noOptionsText={"No directions found"}
      />
      <FormHelperText error={!!error}>
        {error ? error.message : ""}
      </FormHelperText>
    </FormGroup>
  );
}
